import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=42990e4e"
import script from "./trigger.vue?vue&type=script&lang=ts"
export * from "./trigger.vue?vue&type=script&lang=ts"
import style0 from "./trigger.vue?vue&type=style&index=0&id=42990e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports